import { Injectable } from '@angular/core';
import { CheckboxQuestionV3 } from '@bepatient/common';

@Injectable()
export class BodySchemaUtilsService {
  getForm(
    label: string,
    options: any[]
  ): {
    uuid: string;
    currentPage: number;
    questionPages: CheckboxQuestionV3[][];
    responses: boolean[];
    readonly: boolean;
  } {
    return {
      uuid: label,
      currentPage: 0,
      questionPages: this.getQuestionPages(label, options),
      responses: options.map(() => true),
      readonly: false
    };
  }

  parseResponses(responses: boolean[], options: any[]): string[] {
    return responses
      .map((booleanAsResponse, index) => {
        return !booleanAsResponse ? null : options[index].value;
      })
      .filter(response => !!response);
  }

  private getQuestionPages(label, options): CheckboxQuestionV3[][] {
    return [
      [
        new CheckboxQuestionV3({
          controlType: 0,
          constraints: [{ type: 'required' }],
          disabled: false,
          display: true,
          key: label,
          order: 1,
          page: 0,
          placeholder: '',
          readonly: false,
          required: true,
          customClasses: [''],
          conditionalRules: { isConditionnal: false },
          label,
          options
        })
      ]
    ];
  }
}
